// src/constants/fieldConstants.js

// --- 1. FİZYOGRAFYA & MATERYAL ---

export const FIZYOGRAFYA_OPTIONS = [
  { code: "DB", label: "DB - Dağlık - Boyun - İç bükey" },
  { code: "DD1", label: "DD1 - Dağlık - Doruk - Dış bükey" },
  { code: "DD2", label: "DD2 - Dağlık - Doruk-omuz birliği - Dış bükey" },
  {
    code: "DGÇk",
    label: "DGÇk - Diğer araziler - Kumullar/çöl benzeri - Hafif dalgalı eğim",
  },
  {
    code: "DGSk",
    label:
      "DGSk - Diğer araziler - Kumullar/sahil kumulları/kıyı kordonları - Hafif dalgalı eğim",
  },
  {
    code: "DGSy",
    label: "DGSy - Diğer araziler - Su yüzeyleri (Göl, deniz, baraj vb.) - Düz",
  },
  {
    code: "DGYp",
    label:
      "DGYp - Diğer araziler - Yapay objeler - Yol, kanal, hava alanı sınırları vb.",
  },
  {
    code: "DOd",
    label:
      "DOd - Dağlık - Yüzey akış oyuntuları - Birden fazla, demet şeklinde oyuntular",
  },
  { code: "DOut", label: "DOut - Dağlık - Yüzey akış oyuntuları" },
  {
    code: "DOu",
    label: "DOu - Dağlık - Yüzey akış oyuntuları - “U“ şeklinde oyuntu",
  },
  { code: "DOusy", label: "DOusy - Dağlık - Yüzey akış oyuntuları" },
  {
    code: "DOv",
    label: "DOv - Dağlık - Yüzey akış oyuntuları - “V” şeklinde oyuntu",
  },
  { code: "DS", label: "DS - Dağlık - Sırt - Dış bükey" },
  { code: "Dsay", label: "Dsay - Dağlık" },
  { code: "Dsoy", label: "Dsoy - Dağlık" },
  { code: "DTd", label: "DTd - Dağlık - Tepe üstü düzlüğü - Düz-düze yakın" },
  {
    code: "DY1",
    label: "DY1 - Dağlık - Yamaç - Doğrusal çok dik eğimli (%20-30)",
  },
  { code: "DY2", label: "DY2 - Dağlık - Yamaç - Doğrusal dik eğimli (%12-20)" },
  { code: "DY3", label: "DY3 - Dağlık - Yamaç - Doğrusal orta eğimli (%6-12)" },
  { code: "DY4", label: "DY4 - Dağlık - Yamaç - Doğrusal hafif eğim (%2-6)" },
  {
    code: "DY5",
    label: "DY5 - Dağlık - Yamaç - Dalgalı yüzeyli, karışık eğimli",
  },
  { code: "DY6", label: "DY6 - Dağlık - Yamaç - Sarp (%30+)" },
  {
    code: "DYvdt",
    label: "DYvdt - Dağlık - Yan vadiler - Dere taşkın düzlükleri",
  },
  {
    code: "DYvsy",
    label: "DYvsy - Dağlık - Yan vadiler - Dere yatağı şev yüzeyleri",
  },
  { code: "DYvt", label: "DYvt - Dağlık - Yan vadiler - Dere yatağı tabanı" },
  { code: "DZLykb", label: "DZLykb - Düzlükler - Lav akıntı düzlükleri" },
  {
    code: "DZLysv",
    label: "DZLysv - Düzlükler - Lav akıntı düzlükleri şev yamacı",
  },
  {
    code: "DzDd",
    label:
      "DzDd - Düzlükler - Delta düzlüklerinde depresyonik/ çukur alanlar (ard bataklıklar) - Hafif iç bükey",
  },
  {
    code: "DzDkk",
    label:
      "DzDkk - Düzlükler - Delta düzlüklerinde kıyı kordonları - Hafif dalgalı eğim",
  },
  {
    code: "DzDkt",
    label: "DzDkt - Düzlükler - Delta düzlüklerinde Kum tepeleri",
  },
  {
    code: "DzDkt1",
    label:
      "DzDkt1 - Düzlükler - Delta düzlüklerinde Kum tepeleri - Hafif dalgalı, hafif (% 2-6) eğimli dış bükey",
  },
  {
    code: "DzDkt2",
    label:
      "DzDkt2 - Düzlükler - Delta düzlüklerinde Kum tepeleri - Hafif dalgalı, orta (% 6-12) eğimli dış bükey eğim",
  },
  {
    code: "DzDktr",
    label:
      "DzDktr - Düzlükler - Delta düzlüklerinde kıyı terasları - Hafif dalgalı eğim",
  },
  {
    code: "DzDktry",
    label:
      "DzDktry - Düzlükler - Delta düzlüklerinde kıyı terasları şev yamaçları - Dalgalı hafif/orta eğimli",
  },
  {
    code: "DzDo",
    label: "DzDo - Düzlükler - Delta düzlüklerinde, ovalar - Düze yakın eğimli",
  },
  {
    code: "DzDSk",
    label:
      "DzDSk - Düzlükler - Delta düzlüklerinde sahil kumulları - Hafif dalgalı eğim",
  },
  {
    code: "DzDsb",
    label:
      "DzDsb - Düzlükler - Delta Düzlüklerinde Sahil Bataklıkları - Düze yakın",
  },
  {
    code: "DzDSy",
    label: "DzDSy - Düzlükler - Delta düzlüklerinde Su yüzeyleri (Lagün) - Düz",
  },
  {
    code: "DzGd",
    label:
      "DzGd - Düzlükler - Göl tabanı düzlüklerinde, aşınmış dalgalı topoğrafyalı araziler",
  },
  {
    code: "DzGd1",
    label:
      "DzGd1 - Düzlükler - Göl tabanı düzlükleri aşınmış - İç bükey-dış bükey birlikte hafif eğimli (% 2-6)",
  },
  {
    code: "DzGd2",
    label:
      "DzGd2 - Düzlükler - Göl tabanı düzlükleri aşınmış - İç bükey-dış bükey birlikte orta eğimli (%6-12)",
  },
  {
    code: "DzGdp",
    label:
      "DzGdp - Düzlükler - Göl tabanında Aşınma-erime ya da çöküntü - İç bükey %0-6 eğim",
  },
  {
    code: "DzGOd",
    label:
      "DzGOd - Düzlükler - Göl tabanı terasları yüzey akış oyuntuları - Birden fazla, demet şeklinde oyuntular",
  },
  {
    code: "DzGOu",
    label:
      "DzGOu - Düzlükler - Göl tabanı terasları yüzey akış oyuntuları - (U) şekilli iç bükey",
  },
  {
    code: "DzGOv",
    label:
      "DzGOv - Düzlükler - Göl tabanı terasları yüzey akış oyuntuları - (V) şekilli iç bükey",
  },
  {
    code: "DzGt",
    label:
      "DzGt - Düzlükler - Göl tabanı düzlükleri - Düz–düze yakın eğimli, (% 0-2)",
  },
  {
    code: "DzGTru",
    label:
      "DzGTru - Düzlükler - Göl tabanı terasları - Karışık eğimli teras üstü düzlükleri",
  },
  {
    code: "DzGTrua",
    label:
      "DzGTrua - Düzlükler - Göl tabanı terasları - Karışık eğimli teras üstü düzlükleri (%0-2)",
  },
  {
    code: "DzGTrub",
    label:
      "DzGTrub - Düzlükler - Göl tabanı terasları - Karışık eğimli teras üstü düzlükleri (%2-6)",
  },
  { code: "DzGTruv", label: "DzGTruv - Düzlükler - Göl tabanı terasları" },
  { code: "DzGTrY", label: "DzGTrY - Düzlükler - Göl tabanı teras yamaçları" },
  {
    code: "DzGTrY1",
    label:
      "DzGTrY1 - Düzlükler - Göl tabanı teras yamaçları - Doğrusal çok dik eğimli (%20-30)",
  },
  {
    code: "DzGTrY2",
    label:
      "DzGTrY2 - Düzlükler - Göl tabanı teras yamaçları - Doğrusal dik eğimli (%12-20)",
  },
  {
    code: "DzGTrY3",
    label:
      "DzGTrY3 - Düzlükler - Göl tabanı teras yamaçları - Doğrusal orta eğimli (%6-12)",
  },
  {
    code: "DzGTrY4",
    label:
      "DzGTrY4 - Düzlükler - Göl tabanı teras yamaçları - Doğrusal hafif eğimli (%2-6)",
  },
  {
    code: "DzGTrY5",
    label: "DzGTrY5 - Düzlükler - Göl tabanı teras yamaçları - Dalgalı eğimli",
  },
  {
    code: "DzItd",
    label:
      "DzItd - Düzlükler - Düzlüklerde dere/ırmak taşkın düzlükleri - Düze yakın, hafif dalgalı",
  },
  {
    code: "DzItr",
    label:
      "DzItr - Düzlükler - Düzlüklerde dere/ırmak terasları - Düze yakın, hafif dalgalı",
  },
  {
    code: "DzIy",
    label:
      "DzIy - Düzlükler - Düzlüklerde dere/ırmak yatakları - Hafif iç bükey",
  },
  {
    code: "DzIykb",
    label:
      "DzIykb - Düzlükler - Düzlüklerde dere/ırmak yatakları kum bankları - Düze yakın, hafif dalgalı",
  },
  {
    code: "DzIysv",
    label:
      "DzIysv - Düzlükler - Düzlüklerde dere/ırmak yatakları şev yamaçları - Dalgalı hafif-orta eğim",
  },
  {
    code: "DzLv",
    label:
      "DzLv - Düzlükler - Lav akıntı düzlükleri - Düz-düze yakın, hafif dalgalı eğimli",
  },
  {
    code: "DzTk",
    label: "DzTk - Düzlükler - Tektonik çöküntü / karstik düzlükleri",
  },
  {
    code: "DzTs",
    label:
      "DzTs - Düzlükler - Düzlüklerde taşlık-kayalıklar (Lapya) - Düze yakın, hafif dalgalı",
  },
  {
    code: "EBk",
    label:
      "EBk - Etek araziler (Piedmont) - Birikim konileri - İki yönlü eğimli, koni şekilli",
  },
  { code: "Ebj1", label: "Ebj1 - Etek araziler (Piedmont) - Bajadalar" },
  { code: "Ebj2", label: "Ebj2 - Etek araziler (Piedmont) - Bajadalar" },
  { code: "Ebj3", label: "Ebj3 - Etek araziler (Piedmont) - Bajadalar" },
  {
    code: "Ebja",
    label:
      "Ebja - Etek araziler (Piedmont) - Bajadalar - % 0-2 (düze yakın) eğimli aşağı bajadalar",
  },
  {
    code: "Ebjb",
    label:
      "Ebjb - Etek araziler (Piedmont) - Bajadalar - % 2-6 eğimli hafif iç bükey",
  },
  {
    code: "Ebjc",
    label:
      "Ebjc - Etek araziler (Piedmont) - Bajadalar - % 6 ve üstü eğimli hafif iç bükey",
  },
  {
    code: "Ebya",
    label:
      "Ebya - Etek araziler (Piedmont) - Birikim yelpazeleri - Düze yakın eğimli, aşağı yelpaze (%0-2)",
  },
  {
    code: "Ebyb",
    label:
      "Ebyb - Etek araziler (Piedmont) - Birikim yelpazeleri - İki yönlü hafif (% 2-6) eğimli, orta yelpaze",
  },
  {
    code: "Ebyc",
    label:
      "Ebyc - Etek araziler (Piedmont) - Birikim yelpazeleri - İki yönlü orta (% 6-12) eğimli, yukarı yelpaze",
  },
  {
    code: "Ebyy",
    label: "Ebyy - Etek araziler (Piedmont) - Birikim yelpazeleri",
  },
  {
    code: "EC1",
    label:
      "EC1 - Etek araziler (Piedmont) - Etek Düzlükleri - Orta eğimli (%6-12) dalgalı arazilerde çukurluklar",
  },
  {
    code: "EC2",
    label:
      "EC2 - Etek araziler (Piedmont) - Etek Düzlükleri - Hafif eğimli, dalgalı arazilerde çukurluklar (%2-6)",
  },
  {
    code: "EDp",
    label:
      "EDp - Etek araziler (Piedmont) - Etek düzlüklerinde çukurluklar (Depresyonik alanlar) - İç bükey eğimli",
  },
  {
    code: "EEd1",
    label:
      "EEd1 - Etek araziler (Piedmont) - Etek Düzlükleri - Doğrusal orta eğimli (%6-12) etek araziler",
  },
  {
    code: "EEd2",
    label:
      "EEd2 - Etek araziler (Piedmont) - Etek Düzlükleri - Doğrusal hafif eğimli (%2-6) orta etek araziler",
  },
  {
    code: "EKOL",
    label:
      "EKOL - Etek araziler (Piedmont) - Etek düzlükleri (Kolüviyaller) - Doğrusal eğimli araziler",
  },
  {
    code: "Elkb",
    label:
      "Elkb - Etek araziler (Piedmont) - Dere/ırmak yatakları kum bankları - Dalgalı yada hafif dış bükey eğimli",
  },
  {
    code: "Ely",
    label:
      "Ely - Etek araziler (Piedmont) - Dere/ırmak yatakları - İç bükey eğimli",
  },
  {
    code: "Elysy",
    label:
      "Elysy - Etek araziler (Piedmont) - Dere/ırmak yatakları şev yamacı - Doğrusal düz/dalgalı eğim",
  },
  {
    code: "Elytd",
    label:
      "Elytd - Etek araziler (Piedmont) - Dere/ırmak yatakları taşkın düzlüğü - Düze yakın eğimli",
  },
  {
    code: "ES1",
    label:
      "ES1 - Etek araziler (Piedmont) - Etek Düzlükleri - Orta eğimli dalgalı arazilerde sırtlar (%6-12)",
  },
  {
    code: "ES2",
    label:
      "ES2 - Etek araziler (Piedmont) - Etek Düzlükleri - Hafif eğimli, dalgalı arazilerde sırtlar (%2-6)",
  },
  {
    code: "ESCK",
    label:
      "ESCK - Etek araziler (Piedmont) - Etek Düzlükleri - Düze yakın (%0-2) eğimli dalgalı arazilerde sırt ve çukur birliği",
  },
  {
    code: "ESy1",
    label:
      "ESy1 - Etek araziler (Piedmont) - Etek Düzlükleri - Orta eğimli dalgalı arazilerde yamaçlar (%6-12)",
  },
  {
    code: "PTC",
    label:
      "PTC - Plato - Doğal aşınma çukurlukları (Dolin, Uvala, Polje) - İç bükey, derin çukurluklar",
  },
  {
    code: "PTD",
    label: "PTD - Plato - Şahit tepeler; doruk/ doruk omuz birliği - Dış bükey",
  },
  {
    code: "PTE",
    label: "PTE - Plato - Şahit tepeler; Etek araziler - Hafif iç bükey",
  },
  {
    code: "PTIkb",
    label: "PTIkb - Plato - Dere/Irmak yatakları - Düze yakın eğimli",
  },
  { code: "PTly", label: "PTly - Plato - Dere/Irmak yatakları - İç bükey" },
  {
    code: "PTlytd",
    label:
      "PTlytd - Plato - Dere yatağı taşkın düzlükleri/dere bankları - Düze yakın eğimli",
  },
  {
    code: "PTO",
    label: "PTO - Plato - Yüzey akış oyuntuları (Gully) - İç bükey eğim",
  },
  { code: "PTrsv", label: "PTrsv - Plato - Teras şev yüzeyi" },
  {
    code: "PTU1",
    label:
      "PTU1 - Plato - Tepe üstü düzlükleri (Mesa, üstü düz olan yüksek teraslar) - Düze yakın eğim",
  },
  {
    code: "PTU2",
    label:
      "PTU2 - Plato - Tepe üstü düzlükleri (Mesa, üstü düz olan yüksek teraslar) - Düze yakın eğim",
  },
  {
    code: "PTU3",
    label:
      "PTU3 - Plato - Tepe üstü düzlükleri (Mesa, üstü düz olan yüksek teraslar) - Düze yakın eğim",
  },
  {
    code: "PTY",
    label:
      "PTY - Plato - Şahit tepeler; Yamaç araziler - Dalgalı orta/dik eğimli",
  },
  { code: "TB", label: "TB - Tepelik - Boyun - İç bükey" },
  { code: "TD1", label: "TD1 - Tepelik - Doruk - Dış bükey" },
  { code: "TD2", label: "TD2 - Tepelik - Doruk omuz birliği - Dış bükey" },
  {
    code: "TNZ",
    label: "TNZ - Diğer araziler - Fizyoğrafyası tanımlanamayan şekiller",
  },
  {
    code: "TOd",
    label:
      "TOd - Tepelik - Yüzey akış oyuntuları - Birden fazla, demet şeklinde oyuntular",
  },
  { code: "TOut", label: "TOut - Tepelik - Yüzey akış oyuntuları" },
  {
    code: "TOu",
    label:
      "TOu - Tepelik - Yüzey akış oyuntuları - “U” şeklinde oyuntular/Oyuntu tabanı/Oyuntu şev yüzeyi",
  },
  { code: "TOusy", label: "TOusy - Tepelik - Yüzey akış oyuntuları" },
  {
    code: "TOv",
    label: "TOv - Tepelik - Yüzey akış oyuntuları - “V” şeklinde oyuntular",
  },
  { code: "TS", label: "TS - Tepelik - Sırt - Dış bükey" },
  { code: "Tsay", label: "Tsay - Tepelik" },
  { code: "Tsoy", label: "Tsoy - Tepelik" },
  { code: "TTd", label: "TTd - Tepelik - Tepe üstü düzlüğü - Düz- düze yakın" },
  { code: "TVkl", label: "TVkl" },
  { code: "TVkr", label: "TVkr" },
  {
    code: "TY1",
    label: "TY1 - Tepelik - Yamaç - Doğrusal çok dik eğim (%20-30)",
  },
  { code: "TY2", label: "TY2 - Tepelik - Yamaç - Doğrusal dik eğim (%12-20)" },
  { code: "TY3", label: "TY3 - Tepelik - Yamaç - Doğrusal orta eğim (%6-12)" },
  { code: "TY4", label: "TY4 - Tepelik - Yamaç - Doğrusal hafif eğim (%2-6)" },
  { code: "TY5", label: "TY5 - Tepelik - Yamaç - Dalgalı karışık eğim" },
  { code: "TY6", label: "TY6 - Tepelik - Yamaç - Sarp" },
  {
    code: "TYvdt",
    label: "TYvdt - Tepelik - Yan vadiler - Dere taşkın düzlükleri",
  },
  {
    code: "TYvsy",
    label: "TYvsy - Tepelik - Yan vadiler - Dere yatağı şev yüzeyleri",
  },
  { code: "TYvt", label: "TYvt - Tepelik - Yan vadiler - Dere yatağı tabanı" },
  {
    code: "VDp",
    label: "VDp - Vadi - Depresyonik alanlar (Ard bataklıklar) - İçbükey",
  },
  {
    code: "VIkb",
    label:
      "VIkb - Vadi - Irmak yatağı içi çakıl-kum bankları - Düze yakın yada dış bükey parçalı yığınlar",
  },
  {
    code: "VIs",
    label:
      "VIs - Vadi - Nehir sırtı / ırmak doğal seddesi (Levee) - Hafif dış bükey eğim",
  },
  {
    code: "VItd",
    label: "VItd - Vadi - Irmak Taşkın düzlüğü - Düze yakın/hafif eğim",
  },
  { code: "VIy", label: "VIy - Vadi - Irmak yatağı - İç bükey" },
  {
    code: "VIysy",
    label:
      "VIysy - Vadi - Irmak yatağı şev yüzeyi - Doğrusal, düz/dalgalı eğim",
  },
  { code: "VTov", label: "VTov - Vadi - Taşkın ovaları - Düz-düze yakın eğim" },
  {
    code: "VTru",
    label:
      "VTru - Vadi - Teras üstü - Düz-düze yakın eğimli, kesikli veya sürekli basamaklı yapı",
  },
  {
    code: "VTrsv",
    label: "VTrsv - Vadi - Teras şev yüzeyi - Doğrusal hafif eğim",
  },
];

export const ANA_MATERYAL_OPTIONS = [
  "Aluviyal",
  "Fluviyal",
  "Karışık",
  "Koluviyal",
  "Lakustrin",
  "Lös",
  "Marn",
  "Organik",
  "Volkan Külü",
  "Proklastik",
  "Saprolit",
  "Aeolian",
  "Çamur Akıntısı",
];

// --- 2. ARAZİ KULLANIMI & VEJETASYON (YENİLENEN KISIM) ---

export const ARAZI_KULLANIM_KATEGORI_OPTIONS = [
  "Bağ (Ba)",
  "Bahçe (B)",
  "Çayır (Ç)",
  "Funda - Çalılık (F)",
  "Hali Arazi, Boş (H)",
  "Irmak Yatağı (IY)",
  "Kuru Tarım Arazisi (K)",
  "Mera (M)",
  "Nadassız Kuru Tarım (N)",
  "Orman (O)",
  "Özel Ürün (Z)",
  "Sulanan Tarım Arazisi (Sy)",
  "Sulu Tarım Arazisi (S)",
  "Terkedilmiş Araziler (T)",
];

// Alt Sınıf / Ayrıntı (Bunu veritabanı detayı için tutabilirsin, formüle girmez)
export const ARAZI_KULLANIM_DETAY_OPTIONS = [
  "Dikili Tarım",
  "Marjinal Tarım",
  "Mutlak Tarım",
  "Örtü Altı Tarım",
  "Özel Ürün",
  "Tarım Dışı",
];

// Mevcut Ürün Deseni (Türkiye Geneli Yaygın Ürünler)
export const URUN_OPTIONS = [
  "Ağaç",
  "Anason",
  "Armut",
  "Arpa",
  "Ayçiçeği",
  "Bağdem",
  "Bezelye",
  "Biber",
  "Buğday",
  "Ceviz",
  "Çavdar",
  "Çeltik",
  "Çilek",
  "Diğer",
  "Domates",
  "Dut",
  "Elma",
  "Fasulye",
  "Fiğ",
  "Funda",
  "Havuç",
  "Kabak",
  "Karpuz",
  "Kavun",
  "Kayısı",
  "Kiraz",
  "Korunga",
  "Marul",
  "Maydanoz",
  "Mera",
  "Mercimek",
  "Mısır",
  "Nadas",
  "Nohut",
  "Orman",
  "Otlak Ayrığı",
  "Pamuk",
  "Patates",
  "Sarımsak",
  "Siyah Havuç",
  "Soğan",
  "Ş.Pancarı",
  "Şeftali",
  "Üzüm",
  "Vişne",
  "Yer Fıstığı",
  "Antep Fıstığı",
  "Yeşil Soğan",
  "Yonca",
  "Yulaf",
  "Zeytin",
];

// --- 4. EĞİM & DRENAJ ---

export const EGIM_YUZDE_OPTIONS = [
  "0-2",
  "2-4",
  "4-6",
  "6-8",
  "8-10",
  "10-12",
  "12-14",
  "14-16",
  "16-18",
  "18-20",
  "20-30",
  "30-45",
  "45+",
];

export const EGIM_YONU_OPTIONS = [
  "K (Kuzey)",
  "G (Güney)",
  "D (Doğu)",
  "B (Batı)",
  "KD (Kuzeydoğu)",
  "KB (Kuzeybatı)",
  "GD (Güneydoğu)",
  "GB (Güneybatı)",
  "Düz (Yönsüz)",
];

export const TABII_DRENAJ_OPTIONS = [
  "Drenaja gereksinim yok (İ)",
  "Sulamada drenaj yararlı (K)",
  "Drenaja gereksinim var (F1)",
  "Drenaja gereksinim var (F2)",
  "Su göllenmesi (F3)",
];

export const SEL_BASMASI_OPTIONS = [
  "Yok",
  "Az (Arasıra - F1)",
  "Sık (F2)",
  "Çok Sık (F3)",
];

export const TASKIN_OLASILIGI_OPTIONS = ["Yok", "Var"];

// --- 5. EROZYON & KİMYASAL DURUM ---

export const EROZYON_SEKLI_OPTIONS = [
  "Su - Yüzey Erozyonu",
  "Su - Parmak Erozyonu",
  "Su - Oluk Erozyonu",
  "Su - Tünel Erozyonu",
  "Su - Sel Yarıntısı",
];

export const SU_EROZYON_DERECESI_OPTIONS = [
  "1 - Hafif	(yaklaşık 20-30 cm’lik A horizonunun %25’i gitmiş)",
  "2 - Orta	(yaklaşık 20-30 cm’lık A’nın ve/veya A ve B’nin %25-75’i gitmiş)",
  "3 - Şiddetli	(A horizonunun tamamı ve/veya B ile birlikte profilin 75’inden fazlası gitmiş)",
  "4 - Çok şiddetli(Profilin %75’den fazlası gitmiş ve orijinal derinlikteki profillere çok az rastlanan alanlardır)",
];

export const RUZGAR_ASINDIRMA_OPTIONS = [
  "R1 - Hafif (%25'i gitmiş)",
  "R2 - Orta (%25-75'i gitmiş)",
  "R3 - Şiddetli (%75'den fazlası gitmiş)",
  "R6 - Çok Şiddetli (Orijinal profile az rastlanır)",
];

export const RUZGAR_YIGILMA_OPTIONS = [
  "Y1 - 5 cm’den az depozit",
  "Y2 - 6-35 cm depozit",
  "Y3 - 36-70 cm depozit",
  "Y6 - 71 cm’den çok depozit veya kum tepeleri",
];

// --- 6. YÜZEY ÖZELLİKLERİ ---

export const INSAN_ETKISI_OPTIONS = [
  "Drenaj",
  "Gübreleme",
  "Sedde",
  "Sulama",
  "Sürüm",
  "Teraslama",
  "Tesviye",
];

export const TASLILIK_OPTIONS = [
  "Taşsız",
  "T1 - Hafif Taşlı(%10>)",
  "T2 - Orta Taşlı(%10 - %50)",
  "T3 - Çok Taşlı(%50<)",
];

export const CAKILLILIK_OPTIONS = [
  "Yok",
  "Ç1 - Hafif Çakıllı(%10>)",
  "Ç2 - Orta Çakıllı(%10 - %50)",
  "Ç3 - Çok Çakıllı(%50<)",
];

export const KAYALILIK_OPTIONS = [
  "Yok",
  "R0 - Az Kayalı",
  "R1 - Hafif Kayalı",
  "R2 - Orta Kayalı",
  "R3 - Çok Kayalı",
  "R4 - Pek Çok Kayalı ",
];

export const YUZEY_CATLAK_OPTIONS = [
  "Yok",
  "İnce (<1 cm)",
  "Orta (1-2 cm)",
  "Geniş (2-5 cm)",
  "Çok Geniş (>5 cm)",
];

export const TUZLULUK_OPTIONS = [
  "Tuzsuz (1)",
  "Hafif Tuzlu (2)",
  "Orta Tuzlu (3)",
  "Çok Tuzlu (6)",
];
export const ALKALILIK_OPTIONS = ["Yok", "Orta", "Fazla", "Çok Fazla"];

export const BTG_OPTIONS = [
  "Alüviyal",
  "Alüviyal Sahil Bataklıkları",
  "Bazaltik",
  "Çorak Toprak",
  "Gri-Kahverengi Podzolik Topraklar",
  "Hidromorfik Alüviyal",
  "Kahverengi Orman",
  "Kahverengi Toprak",
  "Kestanerengi Toprak",
  "Kireçsiz Kahverengi",
  "Kireçsiz Kahverengi Orman",
  "Kolüviyal Toprak",
  "Kırmız-Kahverengi Akdeniz Toprakları",
  "Kırmızı Akdeniz",
  "Kırmızı Kestanerengi Toprak",
  "Kırmızı-Sarı Podzolik Toprak",
  "Kırmızımsı Kahverengi Toprak",
  "Organik",
  "Regosol",
  "Rendzina",
  "Sierozem",
  "Vertisol",
  "Yüksek Dağ Çayır Toprakları",
];

export const YUZEY_TOPOGRAFYASI_OPTIONS = [
  "Düz",
  "Hafif Dalgalı",
  "Dalgalı",
  "Çok Dalgalı",
  "Kesik",
  "Ondüleli",
];
